import React from "react";
import live from "../../assets/live.png";
import { derhumOrangeSign } from "../../utils/data";

export default function BiddingActivityList({ bids }) {
  return (
    <div className=" max-w-7xl mx-auto bg-white p-6 h-[612px] border shadow-lg w-full z-50">
      {/* Header section with LIVE indicator */}
      <div className="flex items-center gap-2 bg-[rgba(253,235,229,1)] p-[8px] mb-4">
        <div className="flex items-center text-red-500 font-semibold text-sm tracking-wide">
          {/* <span className="h-2 w-2 bg-red-500 rounded-full mr-2 animate-pulse"></span>
          LIVE */}
          <img src={live} alt="live" className="h-16 object-contain w-16" />
        </div>
        <h3 className="font-semibold text-[16px] text-[rgba(19,19,19,1)] tracking-wide">
          BIDDING ACTIVITY
        </h3>
      </div>

      {/* List of bidding activity */}
      <ul className="overflow-y-auto h-[489.49114990234375px] custom-scrollbar">
        {bids &&
          bids.map((bid) => (
            <li
              key={bid.id}
              className="flex items-center  justify-between py-3 border-b border-gray-200 last:border-b-0"
            >
              {/* Bidder name and time */}
              <div>
                <div className="font-medium text-gray-800">
                  {/* {bid?.bidder?.name}  */}{" "}
                  {bid?.bidder?.id === 1 ? "OnSite" : "Online"}
                </div>
                <div className="text-xs text-gray-400">
                  {/* {bid?.bidder?.buyerId == null ? "OnSite" : "Online"} | */}
                  {/* {bid?.source || "Onsite"} |{" "} */}
                  {new Date(bid?.createdAt).toLocaleString("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                  })}
                </div>
              </div>

              {/* Bid amount */}
              <div className="flex items-center font-bold text-lg text-gray-900">
                <span className="text-orange-500 mr-1">{derhumOrangeSign}</span>
                {bid.amount}
              </div>
            </li>
          ))}
      </ul>
    </div>
  );
}
